<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              @click="$refs.modalModulosProgramaRef.abrir(accionesCrud.REGISTRAR, [])">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Editar"
              small
              :disabled="item == null"
              @click="$refs.modalModulosProgramaRef.abrir(accionesCrud.EDITAR, item)">
              <v-icon>mdi-pencil</v-icon>

              Editar
            </v-btn>

            <v-btn
              small
              class="mx-1"
              :disabled="item == null"
              title="Eliminar"
              @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, nombreItem, `${item.modulo.nombre}`)">
              <v-icon>mdi-close</v-icon>

              Eliminar
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoModulosProgramas ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioModulosPrograma
          ref="modalModulosProgramaRef"
          :nombreRecurso="nombreItem"
          :programaUniversidadId="form.id"
          @actualizarListado="listar" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoModulosProgramas from './ListadoModulosProgramas.vue';
import ModuloProgramaService from '../services/modulo-programa.service';
import ModalFormularioModulosPrograma from './ModalFormularioModulosPrograma.vue';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';

export default {
  name: 'ModalModulosPrograma',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoModulosProgramas,
    ModalFormularioModulosPrograma,
  },
  data() {
    return {
      nombreItem: 'Módulo Programa',
    };
  },
  methods: {
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        programaUniversidadId: this.form.id,
      };

      this.obtenerDatosConNotificacion(ModuloProgramaService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await ModuloProgramaService.remove(this.item.id);
      }

      return response;
    },
  },
};
</script>
